import React from 'react'
import { HiddenContainer, Container, Box, Divider } from './styles'
import { usePagamentoBoleto } from '../../../../../hooks/usePagamentoBoleto'
import { isValidValue } from '../../../../../../../shared/utils/validates'
import { Grid } from '@material-ui/core'
import logoTmovPay from '../../../../../../../shared/assets/images/logoTmovPayGreen.svg'
import { format } from 'date-fns'
import { colors } from '../../../../../../../shared/styles/colors'
import {
  formatBankSlip,
  numberToCurrency,
} from '../../../../../../../shared/utils/formatters'
import { useCartao } from '../../../../../hooks/useCartao'
import { TextBoleto } from 'modules/pagamentos/pages/PagamentoBoleto/components/DetalhePagamentoBoleto/styles'

interface ComprovannteDepositoProp {
  protocolo: string
}
// eslint-disable-next-line react/display-name
const ComprovanteDeposito = React.forwardRef<
  React.ReactElement,
  React.PropsWithChildren<ComprovannteDepositoProp>
>((props, ref) => {
  const { boletoDeposito } = usePagamentoBoleto()
  const { cartao } = useCartao()

  return (
    <HiddenContainer>
      {isValidValue(boletoDeposito) && (
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        <Container ref={ref}>
          <Grid container spacing={0}>
            <Grid item xs={12}>
              <Grid
                container
                spacing={0}
                style={{
                  textAlign: 'center',
                }}
              >
                <Grid item xs={12}>
                  <img src={logoTmovPay} height={40} />
                </Grid>
                <Grid item xs={12}>
                  <TextBoleto
                    $fontSize={'18px'}
                    $fontWeight={'700'}
                    $color={colors.gray1}
                  >
                    Comprovante de depósito
                  </TextBoleto>
                </Grid>
                <Grid
                  item
                  xs={12}
                  style={{
                    marginTop: 8,
                  }}
                >
                  <TextBoleto
                    $fontSize={'14px'}
                    $fontWeight={'400'}
                    $color={colors.gray}
                  >
                    {format(new Date(), 'dd/MM/yyyy H:mm:ss')}
                  </TextBoleto>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12}>
              <Grid
                container
                spacing={0}
                style={{
                  margin: 16,
                }}
              >
                <Box>
                  <Grid item xs={12}>
                    <TextBoleto
                      $fontSize={'18px'}
                      $fontWeight={'700'}
                      $color={colors.gray1}
                    >
                      Detalhes
                    </TextBoleto>
                  </Grid>
                </Box>
                <Box>
                  <Grid item xs={12}>
                    <TextBoleto
                      $fontSize={'16px'}
                      $fontWeight={'400'}
                      $color={colors.gray7}
                    >
                      Favorecido
                    </TextBoleto>
                  </Grid>

                  <Grid item xs={12}>
                    <TextBoleto
                      $fontSize={'16px'}
                      $fontWeight={'600'}
                      $color={colors.gray1}
                    >
                      {boletoDeposito.favorecido}
                    </TextBoleto>
                  </Grid>
                </Box>

                <Grid
                  item
                  xs={6}
                  style={{
                    marginTop: 8,
                  }}
                >
                  <TextBoleto
                    $fontSize={'16px'}
                    $fontWeight={'400'}
                    $color={colors.gray7}
                  >
                    Valor
                  </TextBoleto>
                </Grid>
                <Grid
                  item
                  xs={6}
                  style={{
                    marginTop: 8,
                  }}
                >
                  <TextBoleto
                    $fontSize={'16px'}
                    $fontWeight={'400'}
                    $color={colors.gray7}
                  >
                    Desconto
                  </TextBoleto>
                </Grid>

                <Grid
                  item
                  xs={6}
                  style={{
                    marginBottom: 8,
                  }}
                >
                  <TextBoleto
                    $fontSize={'16px'}
                    $fontWeight={'600'}
                    $color={colors.gray1}
                  >
                    {numberToCurrency(boletoDeposito?.valor ?? 0)}
                  </TextBoleto>
                </Grid>
                <Grid
                  item
                  xs={6}
                  style={{
                    marginBottom: 8,
                  }}
                >
                  <TextBoleto
                    $fontSize={'16px'}
                    $fontWeight={'600'}
                    $color={colors.gray1}
                  >
                    {numberToCurrency(boletoDeposito?.valor_desconto ?? 0)}
                  </TextBoleto>
                </Grid>

                <Grid
                  item
                  xs={6}
                  style={{
                    marginTop: 8,
                  }}
                >
                  <TextBoleto
                    $fontSize={'16px'}
                    $fontWeight={'400'}
                    $color={colors.gray7}
                  >
                    Multa
                  </TextBoleto>
                </Grid>
                <Grid
                  item
                  xs={6}
                  style={{
                    marginTop: 8,
                  }}
                >
                  <TextBoleto
                    $fontSize={'16px'}
                    $fontWeight={'400'}
                    $color={colors.gray7}
                  >
                    Juros
                  </TextBoleto>
                </Grid>

                <Grid
                  item
                  xs={6}
                  style={{
                    marginBottom: 8,
                  }}
                >
                  <TextBoleto
                    $fontSize={'16px'}
                    $fontWeight={'600'}
                    $color={colors.gray1}
                  >
                    {numberToCurrency(boletoDeposito?.valor_multa ?? 0)}
                  </TextBoleto>
                </Grid>
                <Grid
                  item
                  xs={6}
                  style={{
                    marginBottom: 8,
                  }}
                >
                  <TextBoleto
                    $fontSize={'16px'}
                    $fontWeight={'600'}
                    $color={colors.gray1}
                  >
                    {numberToCurrency(boletoDeposito?.valor_juros ?? 0)}
                  </TextBoleto>
                </Grid>

                <Grid
                  item
                  xs={12}
                  style={{
                    marginTop: 8,
                  }}
                >
                  <TextBoleto
                    $fontSize={'16px'}
                    $fontWeight={'400'}
                    $color={colors.gray7}
                  >
                    Valor total
                  </TextBoleto>
                </Grid>
                <Grid
                  item
                  xs={12}
                  style={{
                    marginBottom: 8,
                  }}
                >
                  <TextBoleto
                    $fontSize={'16px'}
                    $fontWeight={'600'}
                    $color={colors.gray1}
                  >
                    {numberToCurrency(
                      boletoDeposito?.valor_total ?? boletoDeposito.valor ?? 0,
                    )}
                  </TextBoleto>
                </Grid>

                <Grid
                  item
                  xs={6}
                  style={{
                    marginTop: 8,
                  }}
                >
                  <TextBoleto
                    $fontSize={'16px'}
                    $fontWeight={'400'}
                    $color={colors.gray7}
                  >
                    Vencimento
                  </TextBoleto>
                </Grid>
                <Grid
                  item
                  xs={6}
                  style={{
                    marginTop: 8,
                  }}
                >
                  <TextBoleto
                    $fontSize={'16px'}
                    $fontWeight={'400'}
                    $color={colors.gray7}
                  >
                    Pagamento
                  </TextBoleto>
                </Grid>

                <Grid
                  item
                  xs={6}
                  style={{
                    marginBottom: 8,
                  }}
                >
                  <TextBoleto
                    $fontSize={'16px'}
                    $fontWeight={'600'}
                    $color={colors.gray1}
                  >
                    {format(boletoDeposito.data_vencimento, 'dd/MM/yyyy')}
                  </TextBoleto>
                </Grid>
                <Grid
                  item
                  xs={6}
                  style={{
                    marginBottom: 8,
                  }}
                >
                  <TextBoleto
                    $fontSize={'16px'}
                    $fontWeight={'600'}
                    $color={colors.gray1}
                  >
                    {format(new Date(), 'dd/MM/yyyy')}
                  </TextBoleto>
                </Grid>

                <Grid
                  item
                  xs={12}
                  style={{
                    marginTop: 8,
                  }}
                >
                  <TextBoleto
                    $fontSize={'16px'}
                    $fontWeight={'400'}
                    $color={colors.gray7}
                  >
                    Código
                  </TextBoleto>
                </Grid>
                <Grid
                  item
                  xs={12}
                  style={{
                    marginBottom: 8,
                    wordBreak: 'break-all',
                    paddingRight: 32,
                  }}
                >
                  <TextBoleto
                    $fontSize={'16px'}
                    $fontWeight={'600'}
                    $color={colors.gray1}
                  >
                    {formatBankSlip(boletoDeposito.codigo_barras)}
                  </TextBoleto>
                </Grid>

                <Grid
                  item
                  xs={12}
                  style={{
                    marginTop: 8,
                  }}
                >
                  <TextBoleto
                    $fontSize={'16px'}
                    $fontWeight={'400'}
                    $color={colors.gray7}
                  >
                    Protocolo
                  </TextBoleto>
                </Grid>
                <Grid
                  item
                  xs={12}
                  style={{
                    marginBottom: 8,
                    wordBreak: 'break-all',
                    paddingRight: 32,
                  }}
                >
                  <TextBoleto
                    $fontSize={'16px'}
                    $fontWeight={'600'}
                    $color={colors.gray1}
                  >
                    {props.protocolo}
                  </TextBoleto>
                </Grid>

                <Grid item xs={12}>
                  <Divider />
                </Grid>
                <Box>
                  <Grid item xs={12}>
                    <TextBoleto
                      $fontSize={'18px'}
                      $fontWeight={'700'}
                      $color={colors.gray1}
                    >
                      Pagador
                    </TextBoleto>
                  </Grid>
                </Box>

                <Box>
                  <Grid item xs={12}>
                    <TextBoleto
                      $fontSize={'16px'}
                      $fontWeight={'400'}
                      $color={colors.gray7}
                    >
                      Nome
                    </TextBoleto>
                  </Grid>

                  <Grid item xs={12}>
                    <TextBoleto
                      $fontSize={'16px'}
                      $fontWeight={'600'}
                      $color={colors.gray1}
                    >
                      {cartao.titular ?? 'Teste'}
                    </TextBoleto>
                  </Grid>
                </Box>

                <Box>
                  <Grid item xs={12}>
                    <TextBoleto
                      $fontSize={'16px'}
                      $fontWeight={'400'}
                      $color={colors.gray7}
                    >
                      {isValidValue(cartao?.conta) ? 'Conta' : 'Cartão'}
                    </TextBoleto>
                  </Grid>

                  <Grid item xs={12}>
                    <TextBoleto
                      $fontSize={'16px'}
                      $fontWeight={'600'}
                      $color={colors.gray1}
                    >
                      {cartao?.conta ?? cartao?.identificador ?? 11515151}
                    </TextBoleto>
                  </Grid>
                </Box>

                <Box>
                  <Grid item xs={12}>
                    <TextBoleto
                      $fontSize={'16px'}
                      $fontWeight={'400'}
                      $color={colors.gray7}
                    >
                      Meio de pagamento
                    </TextBoleto>
                  </Grid>

                  <Grid item xs={12}>
                    <TextBoleto
                      $fontSize={'16px'}
                      $fontWeight={'600'}
                      $color={colors.gray1}
                    >
                      TMOV Pay
                    </TextBoleto>
                  </Grid>
                </Box>
              </Grid>
            </Grid>
          </Grid>
        </Container>
      )}
    </HiddenContainer>
  )
})

export default ComprovanteDeposito
